module.exports = __webpack_public_path__ + "static/media/lock.d69aa80a.svg";